import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getDealCompletion,
} from '../../util';

import {
  getAllImperativeTasks,
  getImperativesStages,
} from '../../util/data';

import {
  fetchDealActivity
} from '../../actions/deals';

import { defaults, Line } from 'react-chartjs-2';

import { getIcon } from '../../util/icons';

import ReactTooltip from 'react-tooltip';

import moment from 'moment';

class DealActivity extends Component{

  state = {
    snapshots: null
  }

  itemUpdateIsChange(newValue, oldValue){
    console.log('checking update for change: ', newValue, oldValue);
    if(newValue && oldValue && newValue.status !== oldValue.status){
      //have record of old value and new value, and new value different
      return true;
    }
    else if(newValue && !oldValue){
      console.log('newvalue && !oldValue!');
      console.log('newValue: ', newValue);
      console.log(newValue.status !== 'incomplete');
      //marking something as incomplete which previously didn't exist isn't a change!
      return newValue.status !== 'incomplete';
    }
    else{
      return false;
    }
  }

  mapSnapshotsWithRelativeData(snapshots){
    let mappedSnapshots = [];

    let snapshotsAsArray = _.map(snapshots, (snapshot, timestamp) => {
      return {
        ...snapshot,
        timestamp: parseInt(timestamp)
      }
    });

    //need to reorder, otherwise snapshots are based on string asc, not int asc
    snapshotsAsArray = _.orderBy(snapshotsAsArray, 'timestamp', 'desc');

    console.log('ordered snapshots: ', snapshotsAsArray);
    _.each(snapshotsAsArray, snapshot => {
      console.log('ordered timestamp: ', moment(snapshot.timestamp).format());
      console.log('calculated confidence for snapshot at timestamp: ', getDealCompletion(snapshot).confidence);
    });

    _.each(snapshotsAsArray, (snapshot, snapshotIndex) => {

      //need to know about prior snapshots to determine if any deltas / deal activity
      let snapshotChanges = [];
      let priorSnapshot = snapshotsAsArray[snapshotIndex + 1] || {};

      console.log('priorSnapshot: ', priorSnapshot);

      _.each(getAllImperativeTasks(), imperativeTask => {
        if(this.itemUpdateIsChange((snapshot.imperativeTasks || {})[imperativeTask.id], (priorSnapshot.imperativeTasks || {})[imperativeTask.id])){
          snapshotChanges.push({
            changeType: 'imperativeTask',
            itemId: imperativeTask.id,
            itemName: imperativeTask.text,
            newValue: (snapshot.imperativeTasks || {})[imperativeTask.id],
          });
        }
      });

      //TODO tracking completion of entire imperatives should also show in activity

      _.each(getImperativesStages().objectives, objective => {
        if(this.itemUpdateIsChange((snapshot.funnelTasks || {})[objective.id],(priorSnapshot.funnelTasks || {})[objective.id])){
          snapshotChanges.push({
            changeType: 'objective',
            itemId: objective.id,
            itemName: objective.text,
            newValue: (snapshot.funnelTasks || {})[objective.id]
          });
        }
      });

      _.each(getImperativesStages().reciprocations, reciprocation => {
        if(this.itemUpdateIsChange((snapshot.funnelTasks || {})[reciprocation.id], (priorSnapshot.funnelTasks || {})[reciprocation.id])){
          snapshotChanges.push({
            changeType: 'reciprocation',
            itemId: reciprocation.id,
            itemName: reciprocation.text,
            newValue: (snapshot.funnelTasks || {})[reciprocation.id]
          });
        }
      });

      let confidence = snapshot.confidence || getDealCompletion(snapshot).confidence;
      let confidenceDelta = confidence - (priorSnapshot.confidence || getDealCompletion(priorSnapshot).confidence);

      console.log('confidence for snapshot in order: ', snapshot.confidence);

      console.log('snapshotChanges: ', snapshotChanges);

      mappedSnapshots.push({
        ...snapshot,
        snapshotChanges,
        confidence,
        confidenceDelta,
      });

    });

    return mappedSnapshots;
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.deal && this.props.visible && !prevProps.visible){
      fetchDealActivity(this.props.deal._id, snapshots => {

        const mappedSnapshots = this.mapSnapshotsWithRelativeData(snapshots);

        this.setState({
          snapshots: mappedSnapshots
        }, () => {
          ReactTooltip.rebuild();
        });
      });
    }
  }

  dealWeeklyActivity(){

    let allWeeks = [];

    let addingWeekEndDate = moment().endOf('isoWeek');
    let addingWeekStartDate = moment().startOf('isoWeek');

    while(moment(addingWeekEndDate).diff(moment(this.props.deal.createdOn.toDate())) > 0){

      let dataForWeek = {
        start: addingWeekStartDate.clone(),
        end: addingWeekEndDate.clone(),
        snapshots: _.filter(this.state.snapshots, (snapshot) => {
          return  moment(snapshot.timestamp).diff(addingWeekStartDate) > 0 &&
                  moment(snapshot.timestamp).diff(addingWeekEndDate) < 0;
        })
      }

      //snapshot for end of week is either the last snapshot within this week, or it is the last snapshot of all snapshots in history that was generated prior to the end of this week
      dataForWeek.weekHasSnapshot = _.size(dataForWeek.snapshots) > 0;
      dataForWeek.snapshotAtEndOfWeek = dataForWeek.weekHasSnapshot ? _.head(dataForWeek.snapshots) : _.head(_.filter(this.state.snapshots, snapshot => { return moment(snapshot.timestamp).diff(addingWeekEndDate) < 0 }));

      //use confidence prop if exists, or recalculate if it doesn't (older 2019 snapshots of deals won't have this prop)
      dataForWeek.confidenceAtEndOfWeek = dataForWeek.snapshotAtEndOfWeek.confidence;

      dataForWeek.allSnapshotChanges = _.flatten(_.map(dataForWeek.snapshots, 'snapshotChanges'));

      allWeeks.push(dataForWeek);

      //update to new week
      addingWeekEndDate.subtract(7, 'days');
      addingWeekStartDate.subtract(7, 'days');
    }

    return allWeeks;
  }

  dealDailyActivity(){

    let allDays = [];

    let addingDay = moment().startOf('day');

    //need to go one day past start, otherwise we'll stop on this line once we have the final day to check
    while(addingDay.diff(moment(this.props.deal.createdOn.toDate()).subtract(1, 'days')) > 0){

      let endOfToday = addingDay.clone().endOf('day');
      let startOfToday = addingDay.clone();

      let dataForDay = {
        day: addingDay.clone(),
        snapshots: _.filter(this.state.snapshots, (snapshot) => {
          return  moment(snapshot.timestamp).diff(startOfToday) > 0 &&
                  moment(snapshot.timestamp).diff(endOfToday) < 0;
        }),
        isCreatedOnDay: addingDay.format('YYYYMMDD') === moment(this.props.deal.createdOn.toDate()).format('YYYYMMDD'),
      }

      //snapshot for end of week is either the last snapshot within this week, or it is the last snapshot of all snapshots in history that was generated prior to the end of this week
      dataForDay.dayHasSnapshots = _.size(dataForDay.snapshots) > 0;
      dataForDay.snapshotAtEndOfDay = dataForDay.dayHasSnapshots ? _.head(dataForDay.snapshots) : _.head(_.filter(this.state.snapshots, snapshot => { return moment(snapshot.timestamp).diff(endOfToday) < 0 }));

      //use confidence prop if exists, or recalculate if it doesn't (older 2019 snapshots of deals won't have this prop)
      dataForDay.confidenceAtEndOfDay = dataForDay.snapshotAtEndOfDay.confidence;

      dataForDay.allSnapshotChanges = _.flatten(_.map(dataForDay.snapshots, 'snapshotChanges'));

      allDays.push(dataForDay);

      //update to new day
      addingDay.subtract(1, 'days');
    }

    return allDays;
  }

  renderDealActivity(){

    const snapshotTimestamps = Object.keys(this.state.snapshots);

    // console.log('snapshotTimestamps: ', snapshotTimestamps);

    const dailyActivity = this.dealDailyActivity();

    return (
      <div className="activity-list">
        {_.map(dailyActivity, (activityForDay, dayIndex) => {

          let priorDay = this.dealDailyActivity()[dayIndex + 1] || {};

          const dayHasNoChanges = _.size(activityForDay.allSnapshotChanges) === 0;

          const dayConfidenceDelta = priorDay.confidenceAtEndOfDay && (activityForDay.confidenceAtEndOfDay - priorDay.confidenceAtEndOfDay !== 0) ? activityForDay.confidenceAtEndOfDay - priorDay.confidenceAtEndOfDay : false;
          // console.log('activityForDay.confidenceAtEndOfDay: ', activityForDay.confidenceAtEndOfDay);
          // console.log('priorDay.confidenceAtEndOfDay: ', priorDay.confidenceAtEndOfDay);

          //don't render days without activity - except for first day to resolve bug TODO remove
          if(dayHasNoChanges && !activityForDay.isCreatedOnDay){
            return null;
          }

          return(
            <div className="week">
              <div className="start-end-dates">{activityForDay.day.format('MM/DD')}</div>
              {dayConfidenceDelta &&
                <div className="confidence"><small>{priorDay.confidenceAtEndOfDay} &#8594;</small><span>{activityForDay.confidenceAtEndOfDay}%</span></div>
              }
              {priorDay.confidenceAtEndOfDay === 0 &&
                <div className="confidence"><small>0 &#8594;</small><span>{activityForDay.confidenceAtEndOfDay}%</span></div>
              }
              {priorDay.confidenceAtEndOfDay === undefined &&
                <div className="confidence"><span>{activityForDay.confidenceAtEndOfDay}%</span></div>
              }
              {dayHasNoChanges && !activityForDay.isCreatedOnDay &&
                <div className="no-changes-label">No activity</div>
              }
              {dayHasNoChanges && activityForDay.isCreatedOnDay &&
                <div className="no-changes-label">Deal added</div>
              }
              {!dayHasNoChanges &&
                <div className="activity-items">
                  {_.map(activityForDay.allSnapshotChanges, (change, index) => {
                    return (
                      <div key={`change-${index}`} className={`activity-item status-${change.newValue.status}`}>
                        <div className="description">{change.itemName}</div>
                        <div data-for="tooltip-for-change" data-tip={`Marked ${change.newValue.status} on ${moment(change.newValue.updatedOn).format('M/D/YY')}`} className="change-icon">
                          {change.newValue.status === 'complete' && getIcon('check')}
                          {change.newValue.status === 'incomplete' && getIcon('cancel')}
                          {change.newValue.status === 'failed' && getIcon('info-bold')}
                        </div>
                      </div>
                    )
                  })}
                </div>
              }
            </div>
          )
        })}

        {/*For weekly activity
          {_.map(this.dealWeeklyActivity(), (activityForWeek, weekIndex) => {
          let priorWeek = this.dealWeeklyActivity()[weekIndex + 1] || {};

          const weekHasNoChanges = _.size(activityForWeek.allSnapshotChanges) === 0;

          const weekConfidenceDelta = priorWeek.confidenceAtEndOfWeek && (activityForWeek.confidenceAtEndOfWeek - priorWeek.confidenceAtEndOfWeek !== 0) ? activityForWeek.confidenceAtEndOfWeek - priorWeek.confidenceAtEndOfWeek : false;
          console.log('activityForWeek.confidenceAtEndOfWeek: ', activityForWeek.confidenceAtEndOfWeek);
          console.log('priorWeek.confidenceAtEndOfWeek: ', priorWeek.confidenceAtEndOfWeek);
          console.log('weekConfidenceDelta: ', weekConfidenceDelta);
          return(
            <div className="week">
              <div className="start-end-dates">{activityForWeek.start.format('MM/DD')}-{activityForWeek.end.format('MM/DD')}</div>
              {weekConfidenceDelta &&
                <div className="confidence"><small>{priorWeek.confidenceAtEndOfWeek} &#8594;</small><span>{activityForWeek.confidenceAtEndOfWeek}%</span></div>
              }
              {!priorWeek.confidenceAtEndOfWeek &&
                <div className="confidence"><small>0 &#8594;</small><span>{activityForWeek.confidenceAtEndOfWeek}%</span></div>
              }
              {weekHasNoChanges &&
                <div className="no-changes-label">No activity</div>
              }
              {!weekHasNoChanges &&
                <div className="activity-items">
                  {_.map(activityForWeek.allSnapshotChanges, (change, index) => {
                    return (
                      <div key={`change-${index}`} className={`activity-item status-${change.newValue.status}`}>
                        <div className="description">{change.itemName}</div>
                        <div data-for="tooltip-for-change" data-tip={`Marked ${change.newValue.status} on ${moment(change.newValue.updatedOn).format('M/D/YY')}`} className="change-icon">
                          {change.newValue.status === 'complete' && getIcon('check')}
                          {change.newValue.status === 'incomplete' && getIcon('cancel')}
                          {change.newValue.status === 'failed' && getIcon('info-bold')}
                        </div>
                      </div>
                    )
                  })}
                </div>
              }
            </div>
          )
        })}
      })}*/}

        {/*<ReactTooltip id="tooltip-for-change" place="left" effect="solid" />*/}
      </div>
    )
  }

  dataForChart(){

    let dataPoints = [];

    const dealActivityInChronologicalOrder = this.dealDailyActivity().reverse();

    // console.log('dealActivityInChronologicalOrder: ', dealActivityInChronologicalOrder);

    _.each(dealActivityInChronologicalOrder, (activityForDay, dayIndex) => {

      const dayHasChanges = _.size(activityForDay.allSnapshotChanges) > 0;

      //if first day, or the day has changes, or today
      if(dayIndex === 0 || dayHasChanges || activityForDay.day.format('MMDDYYYY') === moment().format('MMDDYYYY')){
        dataPoints.push({
          label: moment(activityForDay.day).format('M/D'),
          x: moment(activityForDay.day).toDate(),
          y: activityForDay.confidenceAtEndOfDay,
        });
      }
    });

    console.log('dataPoints: ', dataPoints);

    return {
      //labels: _.map(dataPoints, 'label'),
      datasets: [{
        label: 'Deal Confidence',
        backgroundColor: '#d8eddc',
        pointBackgroundColor: '#2D9542',
        borderColor: '#2D9542',
        pointHoverRadius: 6,
        pointRadius: 4,
        pointHitRadius: 10,
        data: dataPoints,
        cubicInterpolationMode: 'monotone',
        steppedLine: 'before',
        // data: [{
        //   x: moment().subtract(7, 'days').toDate(),
        //   y: 1
        // }, {
        //   x: moment().subtract(2, 'days').toDate(),
        //   y: 37
        // }, {
        //   x: moment().toDate(),
        //   y: 45
        // }]
      }]
    }
  }
  renderDealConfidenceOverTimeChart(){

    const tooltips = {
      enabled: true,
      callbacks: {
        title: (tooltipItem) => { return `Confidence adjusted to ${tooltipItem[0].value}% on ${moment(tooltipItem[0].label).format('M/D')}.`; },
        label: () => { return null; }
      }
    }

    return (
      <div className="deal-confidence-over-time">
        <Line legend={{display: false}} ref='chart' options={{ tooltips, animation: { duration: 0 }, maintainAspectRatio: false, scales: { yAxes: [{ ticks: { min: 0, max: 100, stepSize: 20 } }], xAxes: [{ type: 'time', unit: 'day' }] } }} height={100} data={this.dataForChart()} />
      </div>
    )
  }

  render(){

    if(!this.props.visible || !this.props.deal){
      return null;
    }

    const {
      snapshots
    } = this.state;

    return (
      <div className={`modal deal-activity`}>
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            <h3>Deal Activity</h3>
            {!snapshots &&
              <p className="loading">Loading...</p>
            }
            {snapshots && this.renderDealConfidenceOverTimeChart()}
            {snapshots && this.renderDealActivity()}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    deal: state.deal.data,
  }
}

export default connect(mapStateToProps, {  })(DealActivity);



// WEBPACK FOOTER //
// ./src/components/modals/dealActivity.js